"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqItems = [{
  question: "Do I need to arrange parking permits for your team in London?",
  answer: "Yes, parking arrangements are essential for our team to operate efficiently. Since we work throughout London, we rely on clients to provide visitor parking permits or access to a driveway for our vans. If your property is in a controlled parking zone (CPZ) without visitor permits, please let us know in advance so we can factor parking costs into the quote or arrange alternative solutions."
}, {
  question: "How long does a full bathroom renovation typically take?",
  answer: "A standard full bathroom refurbishment usually takes between 10 to 15 working days. This timeline allows for demolition, plumbing and electrical first fixes, plastering, waterproofing (tanking), tiling, and final installation of fixtures. More complex projects, such as wet rooms or those requiring structural changes, may take up to 3 weeks. We work Monday to Saturday, 8am - 6pm, to ensure projects are completed promptly."
}, {
  question: "Do you handle waste disposal, especially for flats?",
  answer: "Absolutely. We manage the removal and disposal of all renovation waste. For houses with driveways, we typically use a skip. For London flats or properties with limited access where a skip isn't feasible, we arrange for a licensed waste collection service to remove debris directly. We ensure all waste is disposed of responsibly and recycling is prioritized where possible."
}, {
  question: "Is your work fully insured for London properties?",
  answer: "Yes, SimProTiling is fully insured with comprehensive public liability insurance. We have extensive experience working in high-value properties across Chelsea, Fulham, and greater London, treating every home with the utmost respect and care. We also provide a guarantee on our workmanship to give you complete peace of mind."
}, {
  question: "Do you operate within the Congestion Charge and ULEZ zones?",
  answer: "Yes, we cover all of London, including areas within the Congestion Charge and Ultra Low Emission Zone (ULEZ). Our logistics planning accounts for these zones. For projects within the Congestion Charge zone, we will discuss any necessary logistical arrangements during the initial consultation."
}, {
  question: "Will there be much dust and disruption during the works?",
  answer: "Renovations do create dust, but we take strict measures to minimize it. We use dust sheets to protect your flooring and seal off the bathroom area as much as possible. For properties in shared buildings or flats, we are particularly careful to keep communal areas clean and tidy at the end of each working day."
}];
export default function RenovationFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="renovation-faq" className="bg-white py-20 lg:py-24" ref={ref}>
      <div className="container ml-0 mr-auto px-4 md:px-6 max-w-4xl">
        <div className={cn("mb-12 text-left transition-all duration-700 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4 tracking-tight">
            Renovation FAQ
          </h2>
          <p className="text-lg max-w-2xl ml-0 mr-auto !text-[hsl(0,0%,0%)]">
            Common questions about our bathroom renovation process, logistics, and
            services in London.
          </p>
        </div>

        <div className={cn("bg-card rounded-xl shadow-sm border border-border/50 p-6 md:p-8 transition-all duration-700 delay-200 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <Accordion type="single" collapsible className="w-full">
            {faqItems.map((item, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b-border/60 last:border-0" data-index={i}>
                <AccordionTrigger className="text-primary font-bold text-left text-lg py-5 hover:text-primary/80 hover:no-underline transition-colors">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}